export default __webpack_public_path__ + "static/media/logo.027c0787.jpg";